export interface GeneralState {
   flag: boolean;
   settings: Settings;
   decodedThreeJSData: ThreeJSDataTypes;
   selectedImageView: SelectedImageView;
   isLibraryVisible: boolean;
   coatType: CoatType | null;
   coatThickness: CoatThickness;
   previewZoom: number;
   selectedLayer: string;
}

export enum JOB_STATUS {
   INITIAL = 'Initial',
   UPLOADING = 'Uploading',
   RIP_READY = 'RIPReady',
}

export interface Settings {
   connectionId: string;
   folderName: string;
   jobStatus: JOB_STATUS;
}

export type ThreeJSDataTypes = {
   printColor: string;
   printBW: string;
};

export type SelectedImageView = 'Preview' | 'silver foil' | 'sense' | '';

export type CoatType =
   | 'varnish'
   | 'gold'
   | 'silver'
   | 'silverBlue'
   | 'bronze'
   | 'roseGold'
   | 'champagne'
   | 'emeraldGreen'
   | 'burgundy'
   | 'lavender'
   | 'royalPurple'
   | 'black';

export type CoatThickness = 'min' | 'mid' | 'max';
